import { notification } from "antd";
import axios from "axios";

// Đăng ký nhận tin
export const submitSandboxĐKNT = async (data) => {
    const url = process.env.REACT_APP_API_SANDBOX_DKNT;

    try {
        const response = await axios.post(url, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        notification.error({ message: 'Lỗi submit đăng ký nhận tin!' });
    }
};

// Minigame
export const submitSandboxMinigame = async (data) => {
    const url = process.env.REACT_APP_API_SANDBOX_MINIGAME;

    try {
        const response = await axios.post(url, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        notification.error({ message: 'Lỗi submit đăng ký nhận quà!' });
    }
};